import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Color} from '@mintdata/mint-kit/api/models/Color';
import {FontWeight} from '@mintdata/mint-kit/api/models/FontWeight';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {Typeface} from '@mintdata/mint-kit/api/models/TypeFace';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AFrame} from '@mintdata/mint-kit/api/values/frames/AFrame';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameField} from '@mintdata/mint-kit/api/values/frames/FrameField';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {AStringConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AStringConfig';
import {ColorConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ColorConfig';
import {PositiveUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/PositiveUnitsConfig';
import {UnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/UnitsConfig';

export class Font
{
    @Property<Typeface>({
        title: 'Typeface',
        tip: `Typeface`,
        isRequired: false,
        typeConfig: AStringConfig,
        typeCtor: Typeface,
        binding: BindingConfig.with('@fontTypeface[0]'),
    })
    public typeface:Typeface;

    @Property<FontWeight>({
        title: 'Weight',
        tip: `Weight`,
        isRequired: false,
        typeConfig: AStringConfig,
        typeCtor: FontWeight,
        binding: BindingConfig.with('@fontWeight[0]'),
    })
    public weight:FontWeight;

    @Property<Color>({
        title: 'Color',
        tip: `Color`,
        isRequired: false,
        typeConfig: ColorConfig,
        typeCtor: Color,
    })
    public color:Color;

    @Property<PositiveUnits>({
        title: 'Size',
        tip: `Size`,
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits,
        binding: BindingConfig.with('@fontSize[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public size:PositiveUnits;

    // TODO: MAM-2706
    // @Property<PositiveUnits>({
    // 	title: 'Paragraph',
    // 	tip: `Paragraph`,
    // 	isRequired: true,
    // 	typeConfig: PositiveUnitsConfig,
    // 	typeCtor: PositiveUnits,
    // 	binding: BindingConfig.with('@fontParagraph[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    // })
    // public paragraph:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Line Height',
        tip: `Line Height`,
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits,
        binding: BindingConfig.with('@fontLineHeight[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public lineHeight:PositiveUnits;

    @Property<Units>({
        title: 'Character',
        tip: `Character`,
        isRequired: true,
        typeConfig: UnitsConfig,
        typeCtor: Units,
        binding: BindingConfig.with('@fontLetterSpacing[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public character:Units;

    // @Property<ABoolean>({
    // 	title: 'Font Style',
    // 	tip: `Font Style`,
    // 	isRequired: false,
    // 	typeConfig: ABooleanConfig,
    // 	typeCtor: ABoolean,
    // 	binding: BindingConfig.with('@fontItalic[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    // })
    // public fontStyle:ABoolean;

    @Property<ABoolean>({
        title: 'Underline',
        tip: `Decoration Underline`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with('@fontUnderline[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public decorationUnderline:ABoolean;

    @Property<ABoolean>({
        title: 'Crossed',
        tip: `Decoration Crossed`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with('@fontCrossed[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public decorationCrossed:ABoolean;

    public constructor(typeface:Typeface,
                       weight:FontWeight,
                       color:Color,
                       size:PositiveUnits,
                       // paragraph:PositiveUnits,
                       lineHeight:PositiveUnits,
                       character:Units,
                       // fontStyle:ABoolean,
                       decorationUnderline:ABoolean,
                       decorationCrossed:ABoolean,)
    {

        this.typeface = typeface;
        this.weight = weight;
        this.color = color;
        this.size = size;
        // this.paragraph = paragraph;
        this.lineHeight = lineHeight;
        this.character = character;
        // this.fontStyle = fontStyle;
        this.decorationUnderline = decorationUnderline;
        this.decorationCrossed = decorationCrossed;
    }

    public toString():string
    {
        return this.typeface != null
        && this.weight != null
        && this.color != null
        && this.size != null
        && this.lineHeight != null
        && this.character != null
        // && this.fontStyle != null
        && this.decorationUnderline != null
            ? `"${this.typeface}" ${this.weight} ${this.color} ${this.size}px
			 ${this.lineHeight} ${this.character}
			  ${this.decorationUnderline} ${this.decorationCrossed} `
            : null;
        // && this.decorationUnderline != null
        // 	? `${this.typeface} ${this.weight} ${this.color} ${this.size}px
        // 	 ${this.lineHeight} ${this.character} ${this.fontStyle}
        // 	  ${this.decorationUnderline} ${this.decorationCrossed} `
        // 	: null;
    }

    public toCSS(options:any = {}):React.CSSProperties
    {
        const {
            typeface,
            weight,
            lineHeight,
            color,
            character,
            size,
            // fontStyle,
            decorationUnderline,
            decorationCrossed,
        } = this;

        const fontWeightAndStyleCSS = FontWeight.toCSS(weight);
        // result.fontStyle = fontStyle.value ? 'italic' : 'normal';
        // result.fontWeight = FontWeight.stringToCSSValue(weight.value);

        const result:React.CSSProperties = {...fontWeightAndStyleCSS};

        result.fontFamily = `"${typeface.toString()}"`;
        result.fontSize = size.toCssString();
        result.lineHeight = lineHeight.toCssString();
        result.letterSpacing = character.toCssString();
        result.textDecoration = '';
        result.color = color.toString();

        if( decorationUnderline.value )
        {
            result.textDecoration += 'underline';
        }
        if( decorationCrossed.value )
        {
            result.textDecoration += ' line-through';
        }

        if( options.importants && options.importants.length )
        {
            options.importants.forEach((importantField:string) =>
            {
                if( result[importantField] !== undefined )
                    result[importantField] += ' !important';
            });
        }

        return result;
    };

    public toCssShorthand():string
    {
        // const fontStyle = this.fontStyle.value ? 'italic' : 'normal';
        // const fontWeight = FontWeight.stringToCSSValue(this.weight.value);
        // const fontStyle = FontWeight.stringToCSSStyleValue(this.weight.value);
        const fontWeight = FontWeight.stringToCSSWeightValue(this.weight);

        const fontSize = this.size.toCssString();
        const lineHeight = this.lineHeight.toCssString();
        const fontFamily = this.typeface.toString();

        // return `${fontStyle} ${fontWeight} ${fontSize}/${lineHeight} '${fontFamily}'`;
        return `${fontWeight} ${fontSize}/${lineHeight} "${fontFamily}"`;
    }

    public static small():Font
    {
        return new Font(
            new Typeface(Typeface.HELVETICA_NEUE),
            FontWeight.regular(),
            Color.black(),
            PositiveUnits.fromPixels(13),
            // PositiveUnits.fromPixels(18),
            PositiveUnits.fromPixels(18),
            Units.fromPixels(1),
            // ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
        );
    }

    public static default():Font
    {
        return new Font(
            new Typeface(Typeface.HELVETICA_NEUE),
            FontWeight.regular(),
            Color.black(),
            PositiveUnits.fromPixels(16),
            // PositiveUnits.fromPixels(18),
            PositiveUnits.fromPixels(18),
            Units.fromPixels(1),
            // ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
        );
    }

    public static big():Font
    {
        return new Font(
            Typeface.default(),
            FontWeight.regular(),
            Color.black(),
            PositiveUnits.fromPixels(24),
            // PositiveUnits.fromPixels(28),
            PositiveUnits.fromPixels(28),
            Units.fromPixels(1.4),
            // ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
        );
    }

    public static exampleFrame():IFrame
    {
        return exampleFrame;
    }
}

const exampleFrame:IFrame = new AFrame(
    [
        new FrameField('fontTypeface', Type.String),
        new FrameField('fontWeight', Type.String),
        // new FrameField('fontTypeface', Type.StringEnum),
        // new FrameField('fontWeight', Type.StringEnum),
        new FrameField('fontColorHex', Type.String),
        new FrameField('fontColorAlpha', Type.Number),
        new FrameField('fontSize', Type.String),
        // new FrameField('fontParagraph', Type.String),
        new FrameField('fontLineHeight', Type.String),
        new FrameField('fontLetterSpacing', Type.String),
        // new FrameField('fontItalic', Type.Boolean),
        new FrameField('fontUnderline', Type.Boolean),
        new FrameField('fontCrossed', Type.Boolean),
    ],
    [
        [
            Typeface.default(),
            FontWeight.regular(),
            Color.black().hex,
            Color.black().alpha,
            AString.fromString('16px'),
            // AString.fromString('18px'),
            AString.fromString('18px'),
            AString.fromString('1px'),
            // ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
        ],
    ],
)
    .extendWith(Color.exampleFrame());
